<script>
import { Head } from '@vueuse/head'
export default {
  ...Head,
  name: 'AppHead'
}
</script>
